import CustomModal from "../../../core/components/ui/custom-modal.component"
import EditFunctionModuleForm from "./edit-function-module-form.component";

const EditFunctionModuleModal = ({row, handleRecordChange, openEditModule, setOpenEditModule}) => {
    const handleClose = () => setOpenEditModule(false);
    
    return(
        <CustomModal  
            open={openEditModule}
            handleClose={handleClose}
            title="Edit Function's Module"
        >
            <EditFunctionModuleForm handleClose={handleClose} handleRecordChange={handleRecordChange} row={row}/>
        </CustomModal>
    )
}


export default EditFunctionModuleModal
